export default __webpack_public_path__ + "static/white-mobile-logo-901a2b2ecbdf5b54ec2da62d8c6ab1fb.svg";